import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../AuthModule';
import AdminToolsBackToolbar from './AdminToolsBackToolbar';

const API = process.env.REACT_APP_API_URL || '';

export default function AdminBetaUsersPage() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [statusMsg, setStatusMsg] = useState(null);
  const [actingId, setActingId] = useState(null);

  const load = useCallback(() => {
    if (!user?.id) return;
    setLoading(true);
    setError(null);
    const userIdStr = String(user.id).replace(/n$/, '');
    fetch(`${API}/api/admin/beta-users/pending?userId=${encodeURIComponent(userIdStr)}`)
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.error || 'Virhe ladattaessa hakemuksia.');
        return data;
      })
      .then((data) => {
        setRows(Array.isArray(data.users) ? data.users : []);
      })
      .catch((err) => setError(err.message || 'Virhe'))
      .finally(() => setLoading(false));
  }, [user?.id]);

  useEffect(() => {
    if (user?.role === 'admin') load();
  }, [user?.role, load]);

  const review = (id, action) => {
    if (!user?.id) return;
    setError(null);
    setStatusMsg(null);
    setActingId(id);
    const userIdStr = String(user.id).replace(/n$/, '');
    fetch(`${API}/api/admin/beta-users/${encodeURIComponent(id)}/review`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId: userIdStr, action }),
    })
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.error || 'Toiminto epäonnistui.');
        return data;
      })
      .then((data) => {
        if (action === 'approve' && data?.createdUser) {
          setStatusMsg(
            `Hyväksytty: ${data.createdUser.email} -> ${data.createdUser.username} / ${data.createdUser.displayName}`,
          );
        } else {
          setStatusMsg('Hakemus hylätty.');
        }
        load();
      })
      .catch((err) => setError(err.message || 'Virhe'))
      .finally(() => setActingId(null));
  };

  if (!user) {
    return (
      <div className="App-block Admin-tools-page">
        <AdminToolsBackToolbar />
        <p>Kirjaudu sisään.</p>
      </div>
    );
  }

  if (user.role !== 'admin') {
    return (
      <div className="App-block Admin-tools-page">
        <AdminToolsBackToolbar />
        <p>Tämä sivu on vain ylläpitäjille.</p>
      </div>
    );
  }

  return (
    <div className="App-block Admin-tools-page">
      <AdminToolsBackToolbar />
      <h1 className="Admin-tools-title">Beta-testaajahakemukset</h1>

      <div className="Admin-trivia-suggestions-toolbar">
        <button type="button" className="Button" onClick={load} disabled={loading}>
          {loading ? 'Ladataan…' : 'Päivitä'}
        </button>
      </div>

      {error ? (
        <p className="Admin-daily-question-error" role="alert">
          {error}
        </p>
      ) : null}
      {statusMsg ? (
        <p className="Admin-daily-question-status" role="status">
          {statusMsg}
        </p>
      ) : null}

      {loading && rows.length === 0 ? <p>Ladataan…</p> : null}
      {!loading && rows.length === 0 ? <p>Ei käsittelemättömiä hakemuksia.</p> : null}

      <ul className="Admin-beta-users-list">
        {rows.map((row) => (
          <li key={row.id} className="Admin-beta-users-card">
            <p className="Admin-beta-users-email">
              <strong>{row.email}</strong>
            </p>
            <p className="Admin-beta-users-reason">{row.reason}</p>
            <div className="Admin-beta-users-actions">
              <button
                type="button"
                className="Button Admin-trivia-suggestions-btn-approve"
                disabled={actingId === row.id}
                onClick={() => review(row.id, 'approve')}
              >
                Hyväksy
              </button>
              <button
                type="button"
                className="Button Admin-beta-users-btn-dismiss"
                disabled={actingId === row.id}
                onClick={() => review(row.id, 'dismiss')}
              >
                Hylkää
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
